module.exports = __webpack_public_path__ + "static/media/cover.30f1efac.png";